
import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from './CookieConsentProvider';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';
import CookiePreferences from './CookiePreferences';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';

const CookieBanner: React.FC = () => {
  const { 
    acceptAllCookies, 
    rejectNonEssentialCookies, 
    showCookieBanner,
    showPreferences,
    setShowPreferences
  } = useCookieConsent();

  if (!showCookieBanner) return null;

  return (
    <div className="fixed z-50 left-0 bottom-0 w-full transition-all duration-300 bg-white/90 backdrop-blur-sm border-t border-gray-100 shadow-md">
      <div className="container mx-auto py-3 px-4">
        {!showPreferences ? (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <Cookie className="h-4 w-4 text-gray-400" />
              <p className="text-sm text-gray-600">
                We gebruiken cookies om je ervaring te verbeteren. 
                <Link to="/cookiebeleid" className="text-primary underline mx-1 hover:text-primary/80">
                  Meer info
                </Link>
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={() => setShowPreferences(true)}
                className="text-xs h-8 text-gray-500 hover:text-gray-700"
              >
                Voorkeuren
              </Button>
              <Button 
                variant="outline" 
                size="sm" 
                onClick={rejectNonEssentialCookies}
                className="text-xs h-8 bg-white"
              >
                Alleen noodzakelijke cookies
              </Button>
              <Button 
                variant="default" 
                size="sm" 
                onClick={acceptAllCookies}
                className="text-xs h-8"
              >
                Accepteren
              </Button>
            </div>
          </div>
        ) : (
          <CookiePreferences />
        )}
      </div>
    </div>
  );
};

export default CookieBanner;
